import { z } from 'zod/v4-mini';

import { Schema, cz } from '@/utils/zodUtils.ts';

export type InsulinInjectionMethod = 'pump' | 'pen';

export type InsulinIndicatorsResponse = {
  averageNumberOfInjection: number;
  averageQuantityInjected: {
    bolus: number;
    basal: number;
  };
};

const noIndicatorsSchema = z.pipe(
  z.object({
    detail: z.literal('no data available'),
  }),
  z.transform(() => ({
    averageNumberOfInjection: 0,
    averageQuantityInjected: {
      bolus: 0,
      basal: 0,
    },
  })),
);

const indicatorsSchema: Schema<InsulinIndicatorsResponse> = z.pipe(
  cz.camelCaseObject({
    average_number_of_injections: z.number(),
    average_quantity_injected: z.object({
      bolus: z.number(),
      basal: z.number(),
    }),
  }),
  z.transform(data => ({
    ...data,
    averageNumberOfInjection: data.averageNumberOfInjections,
  })),
);

export const insulinIndicatorsSchema: Schema<InsulinIndicatorsResponse> =
  z.union([noIndicatorsSchema, indicatorsSchema]);

export type InsulinContinuousIndicators = {
  averageNumberOfBolusInjection: number;
  averageBasalQuantityInjected: number;
  averageBolusQuantityInjected: number;
};

const noContinuousIndicatorsSchema = z.pipe(
  z.object({
    detail: z.literal('no data available'),
  }),
  z.transform(() => ({
    averageNumberOfBolusInjection: 0,
    averageBasalQuantityInjected: 0,
    averageBolusQuantityInjected: 0,
  })),
);

const continuousIndicatorsSchema: Schema<InsulinContinuousIndicators> =
  cz.camelCaseObject({
    average_number_of_bolus_injection: z.number(),
    average_basal_quantity_injected: z.number(),
    average_bolus_quantity_injected: z.number(),
  });

export const insulinContinuousIndicatorsSchema: Schema<InsulinContinuousIndicators> =
  z.union([noContinuousIndicatorsSchema, continuousIndicatorsSchema]);
